module.exports = __webpack_public_path__ + "img/undertakingCases8.7913ad7c.jpg";